var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2018_\\xEB\\xEE\\xE9_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5000 3200",
    style: {
      enableBackground: "new 0 0 5000 3200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.32,
    style: {
      fill: "#FFFFFF"
    },
    width: 5000,
    height: 3200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1757.8086 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "P"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1757.8086 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "P")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1880.2397 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "a"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1880.2397 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "a")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1993.3553 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "g"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1993.3553 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "g")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2110.1782 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "e Not "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2110.1782 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "e Not ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2657.6013 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2657.6013 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "F")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2767.7703 1486.6069)",
    style: {
      fill: "#191E3A",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "ound"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2767.7703 1486.6069)",
    style: {
      fill: "none",
      stroke: "#191E3A",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "194.6731px"
    }
  }, "ound"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1932.0874 1161.6831)",
    style: {
      fill: "#2C447D",
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "638.3408px"
    }
  }, "404"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1932.0874 1161.6831)",
    style: {
      fill: "none",
      stroke: "#2C447D",
      strokeWidth: 6,
      strokeMiterlimit: 10,
      fontFamily: "'ArialRoundedMTBold'",
      fontSize: "638.3408px"
    }
  }, "404"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3872"
    },
    d: "M1988.75,1944.05h-82.91c-19.8,0-35.84-16.05-35.84-35.84v-63.56c0-10.92,4.89-20.7,12.59-27.27 h0.01c6.25-5.34,14.37-8.56,23.24-8.56h82.91V1944.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4656A1"
    },
    d: "M2182.03,2014.7h-165.62c-25.57,0-46.31-20.74-46.31-46.32v-183.9 c0-25.57,20.74-46.31,46.31-46.31h165.62V2014.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38488C"
    },
    d: "M2218.49,1721.7v309.46c0,3.36-2.72,6.08-6.08,6.08h-24.3c-3.36,0-6.08-2.72-6.08-6.08V1721.7 c0-3.36,2.72-6.08,6.08-6.08h24.3C2215.77,1715.62,2218.49,1718.35,2218.49,1721.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232851"
    },
    d: "M2218.49,1834.93v-47.13h112.71c13.01,0,23.56,10.55,23.56,23.56l0,0 c0,13.01-10.55,23.56-23.56,23.56H2218.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232851"
    },
    d: "M2218.49,1965.06v-47.13h112.71c13.01,0,23.56,10.55,23.56,23.56v0 c0,13.01-10.55,23.56-23.56,23.56H2218.49z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38488C"
    },
    d: "M2182.03,2014.7h-165.62c-25.57,0-46.31-20.74-46.31-46.32v-183.9c0-25.57,20.74-46.31,46.31-46.31 c13.8,198.57,165.62,216.81,165.62,216.81V2014.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2037.08,
    y: 1869.76,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4051.7808 -298.9139)",
    style: {
      fill: "#2B3872"
    },
    width: 276.53,
    height: 13.35
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3872"
    },
    d: "M2112.02,2014.7h-95.62c-25.57,0-46.31-20.74-46.31-46.32v-129.1 C1970.1,1969.65,2112.02,2014.7,2112.02,2014.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1898.16,
    y: 1872.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 3842.2024 -89.3407)",
    style: {
      fill: "#232851"
    },
    width: 135.23,
    height: 8.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2203.17,
    y: 1803.12,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4038.1062 -415.3693)",
    style: {
      fill: "#15172D"
    },
    width: 47.13,
    height: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2203.17,
    y: 1933.24,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4168.231 -285.2446)",
    style: {
      fill: "#15172D"
    },
    width: 47.13,
    height: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232851"
    },
    d: "M1970.1,1944.05h-64.26c-19.8,0-35.84-16.05-35.84-35.84v-63.56c0-10.92,4.89-20.7,12.59-27.27 h0.01c-12.15,99.07,87.5,114.2,87.5,114.2V1944.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3872"
    },
    d: "M2971.25,1944.05h82.91c19.8,0,35.84-16.05,35.84-35.84v-63.56c0-10.92-4.89-20.7-12.59-27.27 h-0.01c-6.25-5.34-14.37-8.56-23.24-8.56h-82.91V1944.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4656A1"
    },
    d: "M2777.97,2014.7h165.62c25.57,0,46.31-20.74,46.31-46.32v-183.9c0-25.57-20.74-46.31-46.31-46.31 h-165.62V2014.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38488C"
    },
    d: "M2741.51,1721.7v309.46c0,3.36,2.72,6.08,6.08,6.08h24.3c3.36,0,6.08-2.72,6.08-6.08V1721.7 c0-3.36-2.72-6.08-6.08-6.08h-24.3C2744.23,1715.62,2741.51,1718.35,2741.51,1721.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38488C"
    },
    d: "M2777.97,2014.7h165.62c25.57,0,46.31-20.74,46.31-46.32v-183.9c0-25.57-20.74-46.31-46.31-46.31 c-13.8,198.57-165.62,216.81-165.62,216.81V2014.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2646.39,
    y: 1869.76,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4661.0859 -908.2192)",
    style: {
      fill: "#2B3872"
    },
    width: 276.53,
    height: 13.35
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3872"
    },
    d: "M2847.98,2014.7h95.62c25.57,0,46.31-20.74,46.31-46.32v-129.1 C2989.9,1969.65,2847.98,2014.7,2847.98,2014.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2926.61,
    y: 1872.1,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 4870.6592 -1117.7976)",
    style: {
      fill: "#232851"
    },
    width: 135.23,
    height: 8.66
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232851"
    },
    d: "M2989.9,1944.05h64.26c19.8,0,35.84-16.05,35.84-35.84v-63.56c0-10.92-4.89-20.7-12.59-27.27h-0.01 c12.15,99.07-87.5,114.2-87.5,114.2V1944.05z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.32,
    y: 1855.63,
    style: {
      fill: "#2C447D"
    },
    width: 1869.68,
    height: 41.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3090,
    y: 1859.91,
    style: {
      fill: "#2C447D"
    },
    width: 1910.31,
    height: 41.61
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1386.5028 2580.8408)",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "95.9266px"
    }
  }, "We&apos;re sorry, the page you requested could not be found"), /*#__PURE__*/React.createElement("tspan", {
    x: 461.16,
    y: 115.11,
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "95.9266px"
    }
  }, "Please go back to the homepage")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Svg);
export default __webpack_public_path__ + "static/media/404svg.b289c16c197a93ff6a61dacb375db10d.svg";
export { ForwardRef as ReactComponent };